const handleProductShowMore = () => {
  const selectors = {
    section: '.js-show-more-section',
    btn: '.js-show-more-btn',
    text: '.js-show-more-text',
    overlay: '.js-product-overlay',
    header: '.js-header-alt',
  };

  const state = {
    active: 'is-active',
  };

  const classNames = {
    scrolled: 'l-header--scrolled',
  };

  const section = document.querySelector(selectors.section);

  if (!section) return;

  const btn = section.querySelector(selectors.btn);
  const text = section.querySelector(selectors.text);
  const overlay = document.querySelector(selectors.overlay);
  const header = document.querySelector(selectors.header);

  btn.addEventListener('click', () => {
    section.classList.toggle(state.active);
    btn.classList.toggle(state.active);
    overlay?.classList.toggle(state.active);
    document.body.classList.toggle('ui-overflow');
    header?.classList.add(classNames.scrolled);
    const btnText = btn.textContent.trim();

    text.textContent = btn.dataset.text.trim();

    btn.dataset.text = btnText;
  });
};

export default handleProductShowMore;
